import React, { Component } from 'react';


import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';

import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';

import Snackbar from 'material-ui/Snackbar';
import Button from 'material-ui/Button';
import Checkbox from 'material-ui/Checkbox';
import { LinearProgress } from 'material-ui/Progress';
import { FormControlLabel, FormGroup } from 'material-ui/Form';

import URLSearchParams from 'url-search-params';

import p2p from '../lib/p2p';
import Log from './Log';


const styles = {
  container: {
    backgroundColor: 'rgb(96, 125, 139)',
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: -1,
    top: 0,
  },
  root: {
    width: 380,
    margin: '4em auto',
  },
  appBar: {
    backgroundColor: 'rgb(96, 125, 139)',
  },
  form: {
    padding: '2em 2em 2em 2em',
  },
  span: {
    position: 'relative',
  },
  checkbox: {
    //
  },
  div: {
    marginTop: 16,
  }
};

const progress = {
  max: 0,
  curent: 0,
  next: 10,
}

function getStyleButton(disabled) {
  if (disabled) {
    return {
      marginTop: 16,
    }
  }
  return {
    backgroundColor: '#fff',
    color: 'rgba(0, 0, 0, 0.87)',
    marginTop: 16,
  }
}

function getValue(name) {
  return window.localStorage.getItem(name);
}

function setValue(name, data) {
  return window.localStorage.setItem(name, data);
}

function getProgressValue(curent, max) {
  const temp = Math.round(curent / (max / 100));
  return temp;
}

class Main extends Component {

  state = {
    enabled: true,
    err: false,
    key: getValue('ihp2p_key') || '',
    rkey: false,
    pm: false,
    connect: false,
    status: 'CONNECT',
    completed: null,
    file: 0,
    buffer: 10,
  };

  componentDidMount() {
    Object
      .keys(document.styleSheets)
        .forEach(i => {
          if (document.styleSheets[i].ownerNode.dataset.meta === 'MuiCssBaseline') {
            document.styleSheets[i].disabled = true;
          }
        })
    this.autoLogin();
  }

  autoLogin = () => {
    try {
      const urlParams = window.URLSearchParams ? new window.URLSearchParams(window.location.search) : new URLSearchParams(window.location.search);
      const key = urlParams.get('key');
      const pm = urlParams.get('pm') ? true : false;
      const desktop = urlParams.get('desktop') ? true : false;

      if (desktop) {
        document.querySelector('meta[name="viewport"]').setAttribute("content", '');
      }

      if (key) {
        this.setState({
          key,
          pm,
        }, this.handleConnect);
      }
    } catch (e) {

    }
  }

  progress = (info) => {
    if (this.state.enabled && info.type === 'chunk') {
      progress.max = info.length;
      this.setState({ status: 'downloading files...' });
    }

    if (this.state.enabled && info.type === 'next') {
      progress.curent = progress.curent + info.length;
      const proc = getProgressValue(progress.curent, progress.max);
      if (proc >= progress.next) {
        progress.next = progress.next + 5;
        this.setState({ completed: proc });
      }
    }
  };

  handleConnect = () => {
    this.setState({ connect: true });
    p2p(this.handleStatus, this.state, this.progress);
  }

  handleStatus = (e, error) => {
    console.warn(e);

    if (error) {
      let string = e;
      if (e === 'try again') {
        string = 'active session, try again in 1 minute!'
      }
      if (e === 'session timeout') {
        string = 'reset session, try again in 1 minute!'
      }
      this.setState({ status: 'CONNECT', connect: false, err: string });
    } else {
      if (e === 'ok') {
        this.setState({ enabled: null });
      } else {
        if (e === 'registered' && this.state.rkey) {
          setValue('ihp2p_key', this.state.key);
        }
        this.setState({ status: e });
      }
    }
  }

  handleChangeKey = (e) => {
    this.setState({ key: e.target.value });
  }

  handleChangeRkey = (e) => {
    this.setState({ rkey: e.target.checked });
  }

  handleChangePM = (e) => {
    this.setState({ pm: e.target.checked });
  }

  handleClose = () => {
    this.setState({ err: false });
  }

  render() {
    if (this.state.enabled) {
      return (
        <span>
          <div style={styles.container} />
          <Paper style={styles.root} >
            <AppBar style={styles.appBar} position="static">
             <Toolbar>
               <Typography variant="headline" color="inherit">
                 IntraHouse
               </Typography>
             </Toolbar>
           </AppBar>
           <div style={styles.form}>
             <span style={styles.span}>
               <TextField
                 fullWidth
                 tabIndex={2}
                 maxLength={30}
                 label="Please enter you P2P Key"
                 placeholder=""
                 type="text"
                 value={this.state.key}
                 onChange={this.handleChangeKey}
               />
             </span>
             <div style={styles.div} />
             <FormGroup>
               <FormControlLabel
                  control={
                    <Checkbox
                      color="default"
                      checked={this.state.rkey}
                      onChange={this.handleChangeRkey}
                      style={styles.checkbox}
                    />
                  }
                  label="Remember key"
                />
               <FormControlLabel
                   control={
                     <Checkbox
                       color="default"
                       checked={this.state.pm}
                       onChange={this.handleChangePM}
                       style={styles.checkbox}
                     />
                   }
                   label="Use project manager"
                 />
             </FormGroup>
             <Button
               fullWidth
               tabIndex={2}
               variant="raised"
               disabled={this.state.connect}
               style={getStyleButton(this.state.connect)}
               onClick={this.handleConnect}
             >
              {this.state.status}
             </Button>
             <div style={styles.div} />
             {this.state.completed &&
               <LinearProgress
                variant="determinate"
                value={this.state.completed}
               />
             }
           </div>
           <Snackbar
             anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
             open={Boolean(this.state.err)}
             onClose={this.handleClose}
             SnackbarContentProps={{ 'aria-describedby': 'message-id' }}
             message={<span id="message-id">{this.state.err}</span>}
             action={[
             <Button key="close" color="secondary" size="small" onClick={this.handleClose}>
               CLOSE
             </Button>,
           ]}
           />
          </Paper>
          <Log
            connect={this.state.connect}
            status={this.state.status}
            error={this.state.err}
          />
        </span>
      );
    }
    return null;
  }
}


export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js